import React from 'react';
import { currentEnvLabel } from './envLabel';

const STYLES = {
  DEV: { background: '#ffc107', color: '#1f1f1f' },
  LOCAL: { background: '#0b5cad', color: '#ffffff' },
};

const EnvBadge = () => {
  const label = currentEnvLabel();
  if (!label) {
    return null;
  }
  return (
    <span
      data-testid="env-badge"
      title={label === 'LOCAL' ? 'Running on your local machine' : 'Development environment, not production'}
      style={{
        ...STYLES[label],
        display: 'inline-block',
        marginLeft: 8,
        padding: '1px 8px',
        borderRadius: 10,
        fontSize: '0.6em',
        fontWeight: 700,
        letterSpacing: '0.05em',
        lineHeight: 1.5,
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
};

export default EnvBadge;
